export default "__VITE_ASSET__ab41bfe6__"